import React, { useEffect, useState,useRef  } from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import BillingPartyFormProperties from './BillingPartyFormProperties'
import LocalTable from 'src/components/aciacehighway/LocalTable'
import DialogForm from 'src/components/aciacehighway/DialogForm'
import { Card, } from '@material-ui/core'
import Namespace from 'src/constants/locale/Namespace'
import { useFormContext, useWatch } from 'react-hook-form'
import BillingConfigKeys from 'src/constants/locale/key/BillingConfig'
 
const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL },
  CodeMaintenanceType
} = constants

function PartySection(props) {
  const { getValues, setValue } = useFormContext()
  const {  setChargeCodePartiesDirty } = props
  const [dialog, setDialog] = useState({ open: false, chargeCodeParties: null })
  const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.BILLING_CONFIG])
  const translatedTextsObject = makeTranslatedTextsObject()
  const chargeCodeParties = useWatch({ name: 'chargeCodeParties' })

    function makeTranslatedTextsObject() {

        let partyName = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.PARTY_NAME
        )
        let partyIds = translate(
            Namespace.BILLING_CONFIG,
            BillingConfigKeys.PARTY_ID
        )
        return {
            partyName,
            partyIds
        }
  }

  const columns = [
    {
      title: translatedTextsObject.partyName,
      field: 'partyName',
      filterConfig: { type: 'textfield' },
    }
  ]

  function handleAddChargeCodeParties(data) {
    const chargeCodeParties = [...getValues('chargeCodeParties'), data].map(
      (party, index) => ({ ...party, _id: index + 1 })
    )
    setValue('chargeCodeParties', chargeCodeParties)
    setDialog({ open: false, chargeCodeParties: null })
    setChargeCodePartiesDirty(true)
  }

  function handleDeleteChargeCodeParties(data) {
    const chargeCodeParties = [...getValues('chargeCodeParties')].filter((party) =>
      party.id ? party.id !== data.id : party._id !== data._id
    )

    setValue('chargeCodeParties', chargeCodeParties)
    setChargeCodePartiesDirty(true)
  }

  function handleEditChargeCodeParties(data) {
    const chargeCodeParties = [...getValues('chargeCodeParties')]
    const index = chargeCodeParties.findIndex((party) =>
      party.id ? party.id === data.id : party._id === data._id
    )

    chargeCodeParties[index] = data

    setValue('chargeCodeParties', chargeCodeParties)
    setDialog({ open: false, chargeCodeParties: null })
    setChargeCodePartiesDirty(true)
  }

  const openEditDialog = (rowData) => {
    setDialog({
      open: true,
      chargeCodeParties: rowData,
    })
    
    setValue('partyIds', rowData.partyIds)
    setValue('partyName', rowData.partyName)
  }
   
  return (
    <Card variant='outlined'>
      <LocalTable
        actions={[
          {
            buttonProps: { size: 'medium', color: 'secondary' },
            icon: ['fal', 'plus-circle'],
            label: 'Add Party',
            onClick: () => setDialog({ open: true, chargeCodeParties: null })
          }
        ]}
        columns={columns}
        data={chargeCodeParties?.map((party, index) => ({
          ...party,
          _id: party._id || party.id || index 
        }))}
        rowActions={[
          {
            icon: ['fal', 'pen'],
            onClick: (rowData) => openEditDialog(rowData), // Use openEditDialog to initialize values
            tooltip: () => 'Edit'
          },
          {
            icon: ['fal', 'trash'],
            onClick: handleDeleteChargeCodeParties,
            tooltip: () => 'Delete'
          }
        ]}
      />
      <DialogForm
        formProperties={{
          ...BillingPartyFormProperties,
          Fields: (fieldProps) => (
            <BillingPartyFormProperties.Fields
              {...fieldProps}
            partyName={dialog.chargeCodeParties?.partyName || ""}
            partyIds={dialog.chargeCodeParties?.partyIds || ""}
            />
          )
        }}
        fullWidth
        maxWidth='md'
        open={dialog.open}
        onClose={() => setDialog({ open: false, chargeCodeParties: null })}
        onSubmit={
          dialog.chargeCodeParties ? handleEditChargeCodeParties : handleAddChargeCodeParties
        }
        title={`${dialog.chargeCodeParties ? 'Edit' : 'Add'} Party`}
        value={dialog.chargeCodeParties}
      />
    </Card>
  )
}

export default PartySection
